import type {
  ChangeAccountUserRoleCommand,
  ChangeAccountUserRoleResult,
} from "../model/AccountSeatOverview";
import type { AccountManagementService } from "../port/AccountManagementService";

export class ChangeAccountUserRole {
  constructor(private readonly service: AccountManagementService) {}

  execute(
    cmd: ChangeAccountUserRoleCommand,
    signal?: AbortSignal,
  ): Promise<ChangeAccountUserRoleResult> {
    return this.service.changeAccountUserRole(cmd, signal);
  }
}
